import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Form, Modal } from 'react-bootstrap'
import { useAdminMunicipalityOptions } from 'api/hooks/use-admin-municipalities'

// Custom analytics belong to one municipality and are built from a recipe, so
// creating one hands off to that municipality's recipe builder.
const CreateCustomAnalyticModal = ({ show, onHide }) => {
  const navigate = useNavigate()
  const [municipalityId, setMunicipalityId] = useState('')
  const { data: municipalities, isLoading } = useAdminMunicipalityOptions({ options: { enabled: show } })

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!municipalityId) return
    navigate(`/admin/municipalities/${municipalityId}/custom-analytics`)
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Create a custom analytic</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted">
            Custom analytics are built from a recipe for a single municipality. Pick the municipality to open its
            recipe builder.
          </p>
          <Form.Group controlId="custom-analytic-municipality">
            <Form.Label>Municipality</Form.Label>
            <Form.Select value={municipalityId} onChange={(e) => setMunicipalityId(e.target.value)} disabled={isLoading}>
              <option value="">{isLoading ? 'Loading…' : 'Select a municipality…'}</option>
              {municipalities?.map((municipality) => (
                <option key={municipality.id} value={municipality.id}>
                  {municipality.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" className="text-primary" onClick={onHide}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={!municipalityId}>
            Open recipe builder
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default CreateCustomAnalyticModal
